/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useMemo, useState, useRef } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import {
	useReports,
	useReportsByTags,
	useTransactions,
} from 'src/hooks/queries/transactions';
import Icons from 'src/utils/icons';
import request from 'src/utils/request';
import ChangeMonthWrapper from './styles';
import { toEnglishNumbers } from '../../utils/numbers';

const ChangeMonth: React.FC = () => {
	const [monthListModal, setMonthListModal] = useState(false);
	const currentMonthNumber = useRef(
		toEnglishNumbers(
			new Date().toLocaleString('fa-IR', { month: 'numeric' }),
		),
	);
	const [activeMonth, setActiveMonth] = useState<number>(
		Number(currentMonthNumber.current) - 1,
	);
	const { refetch } = useTransactions();
	const { refetch: refetchReports } = useReports();
	const { refetch: refetchReportsByTags } = useReportsByTags();
	const months = useMemo(
		() => [
			'فروردین',
			'اردیبهشت',
			'خرداد',
			'تیر',
			'مرداد',
			'شهریور',
			'مهر',
			'آبان',
			'آذر',
			'دی',
			'بهمن',
			'اسفند',
		],
		[],
	);

	const handleToggleMonthModal = () => {
		setMonthListModal(!monthListModal);
	};

	const handleMonthClick = (monthNumber: number) => {
		const realMonthNumber = monthNumber + 1;
		request.setMonth(realMonthNumber);
		setActiveMonth(monthNumber);
		handleToggleMonthModal();
		refetch();
		refetchReports();
		refetchReportsByTags();
	};

	return (
		<ChangeMonthWrapper>
			<button
				type='button'
				id='change-month-handler'
				onClick={handleToggleMonthModal}
			>
				{Icons.date}
			</button>
			<TransitionGroup>
				{monthListModal && (
					<CSSTransition classNames='FadeBottom' timeout={300}>
						<div id='month-list-wrapper'>
							<ul id='month-list'>
								{months.map((month, index) => (
									<li
										key={index}
										className={`month-item ${
											activeMonth === index
												? ' active'
												: ''
										}`}
									>
										<button
											type='button'
											className='month-button'
											onClick={() =>
												handleMonthClick(index)
											}
										>
											{month}
										</button>
									</li>
								))}
							</ul>
						</div>
					</CSSTransition>
				)}
				{monthListModal && (
					<CSSTransition classNames='simpleFade' timeout={300}>
						<div
							id='modal-overlay'
							onClick={handleToggleMonthModal}
						/>
					</CSSTransition>
				)}
			</TransitionGroup>
		</ChangeMonthWrapper>
	);
};

export default ChangeMonth;
